<script setup lang="ts">
import { computed, ref } from "vue";
import { useTypeDetection } from "~/features/python/ch2/data-types/composables/useTypeDetection";

const rawValue = ref("12");
const targetType = ref<"int" | "float" | "str">("int");
const { convertValue } = useTypeDetection();

const conversion = computed(() => convertValue(rawValue.value, targetType.value));
</script>

<template>
  <article class="space-y-4 rounded-3xl border border-slate-200 bg-white p-5">
    <div class="space-y-1">
      <h2 class="text-lg font-semibold text-slate-900">Aik cheez ko doosri cheez me badlo</h2>
      <p class="text-sm text-slate-600">Yahan dekh sakte ho ke text ko number ya number ko text kaise banaya jata hai.</p>
    </div>

    <div class="grid gap-3 sm:grid-cols-2">
      <label class="space-y-2">
        <span class="text-sm font-medium text-slate-700">Pehli value</span>
        <input
          v-model="rawValue"
          type="text"
          class="w-full rounded-xl border border-slate-200 px-3 py-2 text-sm outline-none focus:border-sky-400"
        >
      </label>

      <label class="space-y-2">
        <span class="text-sm font-medium text-slate-700">Is me badlo</span>
        <select
          v-model="targetType"
          class="w-full rounded-xl border border-slate-200 px-3 py-2 text-sm outline-none focus:border-sky-400"
        >
          <option value="int">int()</option>
          <option value="float">float()</option>
          <option value="str">str()</option>
        </select>
      </label>
    </div>

    <div
      class="rounded-2xl p-4 ring-1"
      :class="conversion.ok ? 'bg-emerald-50 ring-emerald-100' : 'bg-rose-50 ring-rose-100'"
    >
      <p class="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">Naya result</p>
      <p class="mt-1 text-lg font-bold text-slate-900">
        {{ conversion.ok ? conversion.result : 'Yeh change nahi ho saka' }}
      </p>
      <p class="mt-1 text-sm text-slate-700">{{ conversion.message }}</p>
    </div>
  </article>
</template>
